import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

var urlName = "/viewdomain_share_" + Math.floor((Math.random() * 10000));
var mgName = localStorage.getItem('domainRoutUrl_new_3') || '';

if (mgName) {
  urlName = localStorage.getItem('domainRoutUrl_new_3')
} else {
  localStorage.setItem('domainRoutUrl_new_3', urlName)
}


export default new Router({
  mode: "history",
  routes: [
    {
      path: "/", // 默认进入路由
      component:() =>  import("@/views/error/index.vue")
      // redirect: '/kac' //重定向
    },
    {
      path: "/mainboxnew",
      name: "mainboxnew",
      component: () => import("@/components/viewrouter/common.vue"),
      redirect: "/view_anchorgift",
      meta: {
        title: "师兄加油侧滑栏模版",
        index: 700
      },
      children: [
        {
          path: "/view_anchorgift",
          name: "view_anchorgift",
          component: () => import("@/views/anchorgift/index.vue"),
          meta: {
            title: "主播福利",
            index: 701
          }
        },
        {
          path: "/view_redbaggift",
          name: "view_redbaggift",
          component: () => import("@/views/redbaggift/index.vue"),
          meta: {
            title: "红包福利",
            index: 702
          }
        },
        {
          path: "/view_topgift",
          name: "view_topgift",
          component: () => import("@/views/topgift/index.vue"),
          meta: {
            title: "排行福利",
            index: 703
          }
        },
        {
          path: "/view_supreme",
          name: "view_supreme",
          component: () => import("@/views/supreme/index.vue"),
          meta: {
            title: "至尊首领",
            index: 704
          }
        },
        {
          path: "/view_sharegift",
          name: "view_sharegift",
          component: () => import("@/views/sharegift/index.vue"),
          meta: {
            title: "邀请福利",
            index: 705
          }
        },
      ]
    },
    {
      path: "/mainboxnew_ver",
      name: "mainboxnew_ver",
      component: () => import("@/components/view_ver/common.vue"),
      redirect: "/view_anchorgift",
      meta: {
        title: "师兄加油侧滑栏模版",
        index: 800
      },
      children:[
        {
          path: "/view_anchorgift_ver",
          name: "view_anchorgift_ver",
          component: () => import("@/vertical_view/anchorgift/index.vue"),
          meta: {
            title: "竖版_主播福利",
            index: 801
          }
        },
        {
          path: "/view_redbaggift_ver",
          name: "view_redbaggift_ver",
          component: () => import("@/vertical_view/redbaggift/index.vue"),
          meta: {
            title: "竖版_红包福利",
            index: 802
          }
        },
        {
          path: "/view_topgift_ver",
          name: "view_topgift_ver",
          component: () => import("@/vertical_view/topgift/index.vue"),
          meta: {
            title: "竖版_排行福利",
            index: 803
          }
        },
        {
          path: "/view_supreme_ver",
          name: "view_supreme_ver",
          component: () => import("@/vertical_view/supreme/index.vue"),
          meta: {
            title: "竖版_至尊首领",
            index: 804
          }
        },
        {
          path: "/view_sharegift_ver",
          name: "view_sharegift_ver",
          component: () => import("@/vertical_view/sharegift/index.vue"),
          meta: {
            title: "竖版_邀请福利",
            index: 805
          }
        },
        {
          path: "/view_sevengift_ver",
          name: "view_sevengift_ver",
          component: () => import("@/vertical_view/sevengift/index.vue"),
          meta: {
            title: "竖版_七日礼包",
            index: 806
          }
        },
        {
          path: "/view_trialtask_ver",
          name: "view_trialtask_ver",
          component: () => import("@/vertical_view/trialtask/index.vue"),
          meta: {
            title: "竖版_试玩任务",
            index: 807
          }
        },
        {
          path: "/view_pointsredemption_ver",
          name: "view_pointsredemption_ver",
          component: () => import("@/vertical_view/pointsredemption/index.vue"),
          meta: {
            title: "竖版_积分兑换",
            index: 808
          }
        },
        {
          path: "/view_customerservice_ver",
          name: "view_customerservice_ver",
          component: () => import("@/vertical_view/customerservice/index.vue"),
          meta: {
            title: "竖版_客服",
            index: 809
          }
        },
      ]
    },
    {
      path: "/mainboxnew_ver_two",
      name: "mainboxnew_ver_two",
      component: () => import("@/components/view_ver_two/common.vue"),
      redirect: "/view_sevengift_ver_two",
      meta: {
        title: "师兄加油侧滑栏模版",
        index: 900
      },
      children:[
        
        {
          path: "/view_sevengift_ver_two",
          name: "view_sevengift_ver_two",
          component: () => import("@/vertical_view_two/sevengift/index.vue"),
          meta: {
            title: "竖版_七日礼包",
            index: 906
          }
        },
        {
          path: "/view_trialtask_ver_two",
          name: "view_trialtask_ver_two",
          component: () => import("@/vertical_view_two/trialtask/index.vue"),
          meta: {
            title: "竖版_试玩任务",
            index: 907
          }
        },
        {
          path: "/view_pointsredemption_ver_two",
          name: "view_pointsredemption_ver_two",
          component: () => import("@/vertical_view_two/pointsredemption/index.vue"),
          meta: {
            title: "竖版_积分兑换",
            index: 908
          }
        },
        {
          path: "/view_customerservice_ver_two_nee",
          name: "view_customerservice_ver_two_nee",
          component: () => import("@/vertical_view_two/customerservice/index.vue"),
          meta: {
            title: "竖版_客服",
            index: 909
          }
        },
        // {
        //   path: "/view_customerservice_ver_two",
        //   name: "view_customerservice_ver_two",
        //   component: () => import("@/vertical_view_two/customerservice/index.vue"),
        //   meta: {
        //     title: "竖版_客服",
        //     index: 909
        //   }
        // },
      ]
    },
    {
      path: "/view_peak_ver_two",
      name: "view_peak_ver_two",
      component: () => import("@/vertical_view_two/peak/index.vue"),
      meta: {
        title: "竖版_巅峰榜",
        index: 980
      }
    },
    {
      path: "/viewdomain_share",
      name: "viewdomain",
      redirect: urlName 
    },
    {
      path: urlName,
      name: "viewdomain_true",
      component: ()=> import("@/views/domain/index.vue"),
      meta: {
        title: "中间页",
        index: 10
      }
    }
    //,

    // {
    //     path: '**', // 错误路由
    //     component: import("@/views/error/index.vue")
    //     // redirect: '/' //重定向
    // }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(loca, addsearch = true) {
  if (addsearch) {
    loca.path = loca.path + location.search;
  }
  console.log(loca.path);
  return originalPush.call(this, loca).catch(err => err);
};

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js